import React, { useState, useEffect } from "react";
import Data from "../App";
import { map, distinctUntilChanged } from "rxjs/operators";
import CompJsonEdit from "./CompJsonEdit";
import CompView from "./CompView";
import { List, Map, is, fromJS } from "immutable";

const Stream = ({ stream, editing, expanded, onChange }) => {
  function addSignal() {
    let comp = fromJS({
      type: "signalGroup",
      variants: [{ id: 1, name: "tbd" }]
    });
    let newId = Data.getInstance().addComp(comp);
    onChange(stream.set("outSignal", newId));
  }

  function addState() {
    let comp = fromJS({
      type: "state",
      attributes: [{ id: 1, name: "tbd" }]
    });
    let newId = Data.getInstance().addComp(comp);
    onChange(stream.set("outSignal", newId));
  }

  function addStream() {
    let comp = fromJS({
      type: "stream",
      name: "tbd",
      spec: "tbd"
    });
    let newId = Data.getInstance().addComp(comp);
    if (stream.get("streams")) {
      onChange(stream.updateIn(["streams"], list => list.push(newId)));
    } else {
      onChange(stream.set("streams", new List([newId])));
    }
  }

  console.log("outsignal " + stream.get("outSignal"));
  let out = "";
  if (stream.get("outSignal")) {
    out = <CompView compId={stream.get("outSignal")} />;
  } else if (stream.get("outState")) {
    out = <CompView compId={stream.get("outState")} />;
  }
  let addingStream;
  if (editing) {
    addingStream = (
      <div
        className="CompAddItem"
        onClick={e => {
          e.stopPropagation();
          addStream();
        }}
      >
        Add Stream
      </div>
    );
  }
  let addingSignal;
  if (editing && !stream.get("outSignal")) {
    addingSignal = (
      <div
        className="CompAddItem"
        onClick={e => {
          e.stopPropagation();
          addSignal();
        }}
      >
        Add Signal Output
      </div>
    );
  }
  let addingState;
  if (editing && !stream.get("outState")) {
    addingState = (
      <div
        className="CompAddItem"
        onClick={e => {
          e.stopPropagation();
          addState();
        }}
      >
        Add State Output
      </div>
    );
  }
  let editor = "";
  if (editing) {
    editor = (
      <div>
        <CompJsonEdit
          json={JSON.stringify(stream)}
          onSet={newObj => onChange(newObj)}
          filterFct={item => true}
        />
      </div>
    );
  }
  let subStreams = "";
  if (expanded && stream.get("streams"))
    subStreams = (
      <div className="StreamSubstreams">
        {stream.get("streams").map(streamId => (
          <CompView compId={streamId} />
        ))}
      </div>
    );
  return (
    <div className="Stream">
      <div className="StreamContent">
        {addingStream}
        {addingSignal}
        {addingState}
        <div className="StreamName">
          <span>{stream.get("name")}</span>
        </div>
        {stream.get("spec") ? (
          <div className="StreamSpec">{stream.get("spec")}</div>
        ) : (
          ""
        )}
        {editor}
        {subStreams}
      </div>
      <span className="StreamOutputArrow">&#9654;</span>
      {out}
    </div>
  );
};
export default Stream;



// WEBPACK FOOTER //
// ./src/components/Stream.js